// ** Initial State
const initialState = {
  data: [],
  loading: false,
  update: [],
  ics: null
}

const eventSettings = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EVENT_SETTINGS_REQUEST':
      return {
        ...state,
        loading: true
      }
    case 'GET_EVENT_SETTINGS_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.data
      }
    case 'GET_EVENT_SETTINGS_FAILURE':
      return {
        ...state,
        loading: false,
        data: []
      }
    case 'UPDATE_EVENT_SETTINGS':
      return {
        ...state,
        update: action.data
      }
    case 'DELETE_EVENT_SETTINGS':
      return {
        ...state,
        update: action.data
    }
    case 'DOWNLOAD_EVENT_ICS_FILE':
      return {
        ...state,
        ics: action.data
      }
    default:
      return { ...state }
  }
}
export default eventSettings
